import {regexify, valueMatches} from '../common/filters.js';
import {Identity, OriginType} from '../state/types/common.js';
import {IOGateway} from '../../gateway';
import {DomainUri} from "../state/types/domain-registry.ts";

export function defaultPeerRestrictions(domain: DomainUri, rules?: IOGateway.VisibilityRule<'domain'>[]): OriginType | undefined {
    return rules?.filter((rule: IOGateway.VisibilityRule<'domain'>) => {
        return rule.domain === domain;
    })?.find((rule: IOGateway.VisibilityRule<'domain'>) => {
        if (rule.identity === undefined) {
            return true;
        }
        throw new Error('identity in default restrictions rules set is not allowed');
    })?.restrictions;
}

export type RestrictedKey = 'context' | 'method';

export function defaultRestrictions<K extends RestrictedKey>(key: K, rules?: IOGateway.VisibilityRule<K>[]): ((this: Identity, name?: string) => (OriginType | undefined)) {
    const rs = rules?.map(rule => compile(key, rule));
    return function (this: Identity, name?: string): OriginType | undefined {
        return rs?.find((rule: CompiledRule) => {
            return matches(rule, this, name);
        })?.restrictions;
    }
}

type CompiledRule = {
    identity: Record<string, IOGateway.Filtering.Matcher>
    name?: IOGateway.Filtering.Matcher
    restrictions: OriginType
};

function compile<K extends RestrictedKey>(name: K, rule: IOGateway.VisibilityRule<K>): CompiledRule {
    const result: CompiledRule = {identity: {}, restrictions: rule.restrictions};
    if (rule[name]) {
        result.name = regexify(rule[name])
    }
    if (rule.identity) {
        for (const [k, v] of Object.entries<IOGateway.Filtering.Matcher>(rule.identity)) {
            result.identity[k] = regexify(v);
        }
    }
    return result;
}

function matches(rule: CompiledRule, identity: Identity, name?: string): boolean {
    for (const [k, v] of Object.entries(rule.identity)) {
        const rv = identity[k];
        if (!valueMatches(v, rv)) {
            return false;
        }
    }
    if (rule.name && !valueMatches(rule.name, name)) {
        return false;
    }
    return true;
}
